import { useEffect } from "react";

export const useTitle = (title) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export const todayName = () => new Intl.DateTimeFormat("en-GB", { weekday: "long", timeZone: "Europe/London" }).format(new Date());

export const EASE = [0.22, 1, 0.36, 1];
